document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('stjames-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.sj-popup-close');
  const declineBtn = popup.querySelector('.sj-popup-decline');

  const INTERVAL = 15 * 60 * 1000; // 15 min
  const STORAGE_KEY = 'sj_popup_last_shown';

  function openPopup() {
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('body-no-scroll');

    localStorage.setItem(STORAGE_KEY, Date.now());
  }

  function closePopup() {
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('body-no-scroll');
  }

  function shouldShowPopup() {
    const lastShown = localStorage.getItem(STORAGE_KEY);

    if (!lastShown) return true; 

    const timePassed = Date.now() - parseInt(lastShown, 10);

    return timePassed >= INTERVAL;
  }

  
  if (shouldShowPopup()) {
    openPopup();
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (declineBtn) declineBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup();
  });
});